module.exports = __webpack_public_path__ + "img/icone-operational-alert.3e47351c.svg";